module.exports = __webpack_public_path__ + "static/media/1POLICY45.58ae7bf1.jpg";